module.exports = __webpack_public_path__ + "static/img/prince_hotel.525acc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/建置實績/prince_hotel.png?20181011
// module id = W3TF
// module chunks = 1